var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { Routing } from 'src/core/Routing';
import { Document } from 'src/core/Document';
import { Header } from 'src/ui/components/header/Header';
import SnackBar from 'src/ui/components/SnackBar';
import { useMount } from 'src/shared/hooks/useLifecycle';
import { parseUrl } from 'src/shared/helpers/urlHelpers';
import { coreActions } from 'src/redux/core/coreActions';
import store from 'src/shared/store';
import { windowExist } from 'src/shared/constants';
import { EVENT_ON_ERROR } from 'src/services/constants';
import { E_SNACKBAR_TYPE } from 'src/ui/components/SnackBar/SnackBar';
export var App = function () {
    var _a = window.location, host = _a.host, pathname = _a.pathname;
    var urlConfig = parseUrl(host, pathname);
    useMount(function () {
        store.dispatch(coreActions.updateUrlConfRequested(urlConfig));
    });
    useEffect(function () {
        if (windowExist) {
            var handleFetchApiError_1 = function (event) {
                console.error(event.detail);
                store.dispatch(coreActions.addNotificationRequested({
                    type: E_SNACKBAR_TYPE.ERROR,
                    description: "Error code: ".concat(event.detail.status, ", with message: ").concat(event.detail.message, " for url: ").concat(event.detail.url),
                }));
            };
            document.addEventListener(EVENT_ON_ERROR, handleFetchApiError_1);
            return function () { return document.removeEventListener(EVENT_ON_ERROR, handleFetchApiError_1); };
        }
    });
    var headerTitle = "".concat(urlConfig.realm, " - ").concat(urlConfig.env).toUpperCase();
    return (_jsx(Provider, __assign({ store: store }, { children: _jsx(BrowserRouter, { children: _jsxs(Document, { children: [_jsx(Header, { title: headerTitle }), _jsx(SnackBar, {}), _jsx(Routing, { urlConfig: urlConfig })] }) }) })));
};
